import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  AccessibilityReadOnly,
  Arrow,
  ContainerMenuItem,
  MenuItem,
  LinkCustom,
  MenuItemLink,
  MenuItemText,
  SubMenuContainer,
} from './styles';

type SubMenu = Page[];

type Page = {
  name?: string;
  slug?: string[];
  icon?: any;
  key?: string;
  url?: string;
  arialLabel?: string;
  showLink?: boolean;
  subMenu?: SubMenu;
  param?: any;
  type?: string;
};

type NavbarLinkProps = {
  page: Page;
  isSelected: boolean;
  selected: string;
  Icon: any;
  openSub: string;
  setCloseMenu?: () => void;
};

const NavbarLink = ({
  page,
  isSelected,
  selected,
  openSub,
  setCloseMenu,
  ...rest
}: NavbarLinkProps): JSX.Element => {
  const subMenuRef = useRef(null);
  const [subMenuHeight, setSubMenuHeight] = useState(0);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);

  const Icon = page?.icon;

  useEffect(() => {
    if (openSub) {
      setOpenSubMenu(!!page?.slug?.includes(openSub));
    }
  }, [openSub]);

  useEffect(() => {
    if (subMenuRef && subMenuRef.current) {
      const el = subMenuRef.current;

      // @ts-ignore
      setSubMenuHeight(el.childNodes.length * 53 - 15);
    }
  }, [subMenuRef, page]);

  useEffect(() => {
    if (setCloseMenu) {
      setCloseMenu();
    }
  }, [forceUpdate]);

  return (
    <MenuItem {...rest} hidden={!page.showLink}>
      {!page.subMenu && page.showLink && (
        <ContainerMenuItem>
          <Link
            to={{
              pathname: `/${page.url}`,
              key: page.key,
              state: {
                defaultComponent: page.param,
                defaultType: page.type,
              },
            }}
            onClick={() => setForceUpdate(!forceUpdate)}
          >
            <MenuItemLink className="MenuItem" selected={isSelected}>
              <Icon className="icon-navbar-link align-item-menu" />
              <MenuItemText isSelected={isSelected}>{page.name}</MenuItemText>
              <AccessibilityReadOnly>
                {isSelected ? 'Página atual' : ''}
              </AccessibilityReadOnly>
            </MenuItemLink>
          </Link>
        </ContainerMenuItem>
      )}
      {page.subMenu && (
        <ContainerMenuItem>
          <MenuItemLink
            className="MenuItem"
            selected={isSelected}
            onClick={() => setOpenSubMenu(!openSubMenu)}
          >
            <Icon className="icon-navbar-link align-item-menu" />
            <MenuItemText isSelected={isSelected}>{page.name}</MenuItemText>
            <Arrow open={openSubMenu} />
          </MenuItemLink>
          <SubMenuContainer
            ref={subMenuRef}
            height={subMenuHeight}
            open={openSubMenu}
          >
            {page.subMenu.map((submenu) => {
              if (submenu.showLink) {
                const isSelectedSub = submenu?.slug?.includes(selected);

                return (
                  <LinkCustom
                    to={`/${submenu.url}`}
                    aria-label={submenu.arialLabel}
                    key={submenu?.slug?.[0] || ''}
                  >
                    <MenuItemText isSelected={isSelectedSub}>
                      {submenu.name}
                    </MenuItemText>
                    <AccessibilityReadOnly>
                      {isSelectedSub ? 'Página atual' : ''}
                    </AccessibilityReadOnly>
                  </LinkCustom>
                );
              }
              return null;
            })}
          </SubMenuContainer>
        </ContainerMenuItem>
      )}
    </MenuItem>
  );
};

NavbarLink.defaultProps = {
  setCloseMenu: () => null,
};

export default NavbarLink;
